<script setup lang="ts">
/**
 * Pavé numérique sur mesure : 3 colonnes, touches de 56 px de haut, rayon 14 px.
 * Pas de virgule (montants entiers). La touche « 000 » accélère la saisie.
 */
import { fr } from '@/copy/fr'

import Icon from './Icon.vue'

const props = withDefaults(
  defineProps<{ extraKey?: '000' | null; disabled?: boolean; compact?: boolean }>(),
  { extraKey: '000', disabled: false, compact: false },
)

const emit = defineEmits<{ digit: [value: string]; backspace: []; clear: [] }>()

const DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'] as const
/** `compact` : touches de 48 px, pour laisser voir les choix sous le pavé (saisie express). */
const KEY = [
  'flex select-none items-center justify-center rounded-control text-title tabular-nums transition-colors duration-80',
  props.compact ? 'h-12' : 'h-14',
].join(' ')
</script>

<template>
  <div class="grid grid-cols-3 gap-2" role="group" :aria-label="fr.ui.keypad">
    <button
      v-for="digit in DIGITS"
      :key="digit"
      type="button"
      :class="[KEY, 'bg-surface text-ink active:bg-surface-strong']"
      :disabled="disabled"
      @click="emit('digit', digit)"
    >
      {{ digit }}
    </button>
    <button
      v-if="extraKey"
      type="button"
      :class="[KEY, 'text-section text-ink active:bg-surface']"
      :disabled="disabled"
      @click="emit('digit', extraKey)"
    >
      {{ extraKey }}
    </button>
    <span v-else aria-hidden="true" />
    <button
      type="button"
      :class="[KEY, 'bg-surface text-ink active:bg-surface-strong']"
      :disabled="disabled"
      @click="emit('digit', '0')"
    >
      0
    </button>
    <button
      type="button"
      :class="[KEY, 'text-ink active:bg-surface']"
      :aria-label="fr.ui.erase"
      :disabled="disabled"
      @click="emit('backspace')"
      @contextmenu.prevent="emit('clear')"
    >
      <Icon name="back" :size="24" />
    </button>
  </div>
</template>
